import {
  requestCallCenter,
  unwrapEnvelopeValue,
} from "./CallCenterApi";

const CC_ROLE_LIST_MAX_SIZE = 200;

/**
 * @param {object} [params]
 * @param {number} [params.page]
 * @param {number} [params.size]
 * @param {'CODE'|'NAME'|'DISPLAY_NAME'|'CREATED_AT'|'CREATED'} [params.sortBy]
 * @param {'ASC'|'DESC'} [params.sortDir]
 * @param {boolean} [params.includeInactive]
 */
export const listCcAdminRoles = async (params = {}) => {
  const {
    page = 0,
    size = 20,
    sortBy = "CODE",
    sortDir = "ASC",
    includeInactive = false,
  } = params;
  const safeSize = Math.min(
    CC_ROLE_LIST_MAX_SIZE,
    Math.max(1, Number.isFinite(Number(size)) ? Number(size) : 20)
  );
  const safePage = Math.max(0, Number.isFinite(Number(page)) ? Number(page) : 0);
  const envelope = await requestCallCenter({
    method: "GET",
    url: "admin/roles",
    params: {
      page: safePage,
      size: safeSize,
      sortBy,
      sortDir,
      includeInactive,
    },
  });
  return unwrapEnvelopeValue(envelope);
};

/**
 * @param {string|number} roleId
 */
export const getCcAdminRole = async (roleId) => {
  const envelope = await requestCallCenter({
    method: "GET",
    url: `admin/roles/${roleId}`,
  });
  return unwrapEnvelopeValue(envelope);
};

/**
 * @param {Record<string, unknown>} body
 */
export const createCcAdminRole = async (body) => {
  const envelope = await requestCallCenter({
    method: "POST",
    url: "admin/roles",
    data: body,
  });
  return unwrapEnvelopeValue(envelope);
};

/**
 * @param {string|number} roleId
 * @param {Record<string, unknown>} body
 */
export const patchCcAdminRole = async (roleId, body) => {
  const envelope = await requestCallCenter({
    method: "PATCH",
    url: `admin/roles/${roleId}`,
    data: body,
  });
  return unwrapEnvelopeValue(envelope);
};

/**
 * Soft-deactivate role (active = false).
 * @param {string|number} roleId
 */
export const deactivateCcAdminRole = async (roleId) => {
  const envelope = await requestCallCenter({
    method: "DELETE",
    url: `admin/roles/${roleId}`,
  });
  return unwrapEnvelopeValue(envelope);
};

/**
 * All known authority definitions for permission picker.
 */
export const fetchCcAuthorities = async () => {
  const envelope = await requestCallCenter({
    method: "GET",
    url: "security/authorities",
  });
  return unwrapEnvelopeValue(envelope);
};

/**
 * Screen definitions for the role permission matrix.
 */
export const fetchCcScreens = async () => {
  const envelope = await requestCallCenter({
    method: "GET",
    url: "security/screens",
  });
  return unwrapEnvelopeValue(envelope);
};
